import React from 'react';
import { useMsal } from '@azure/msal-react';
import {
    Box,
    Button,
    Typography,
    Paper,
    Container,
} from '@mui/material';
import { Login as LoginIcon } from '@mui/icons-material';

const Login: React.FC = () => {
    const { instance } = useMsal();

    const handleLogin = () => {
        instance.loginRedirect().catch((e: any) => {
            // Erro no login tratado silenciosamente
        });
    };

    return (
        <Box
            sx={{
                minHeight: '100vh',
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                p: 2,
            }}
        >
            <Container maxWidth="sm">
                <Paper
                    elevation={0}
                    sx={{
                        borderRadius: 4,
                        p: 6,
                        textAlign: 'center',
                        background: 'rgba(255, 255, 255, 0.95)',
                        backdropFilter: 'blur(10px)',
                        boxShadow: '0 20px 60px rgba(0, 0, 0, 0.1)',
                    }}
                >
                    <Box
                        sx={{
                            width: 100,
                            height: 100,
                            borderRadius: '50%',
                            bgcolor: 'primary.main',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            mx: 'auto',
                            mb: 4,
                            color: 'white',
                            boxShadow: '0 8px 30px rgba(0, 0, 0, 0.2)',
                        }}
                    >
                        <LoginIcon sx={{ fontSize: 50 }} />
                    </Box>

                    <Typography
                        variant="h3"
                        component="h1"
                        gutterBottom
                        sx={{
                            fontWeight: 800,
                            color: '#1e293b',
                            mb: 2,
                            fontSize: '2.8rem',
                        }}
                    >
                        ILevePDF
                    </Typography>

                    <Typography
                        variant="h6"
                        sx={{
                            color: 'text.secondary',
                            mb: 4,
                            fontWeight: 500,
                            fontSize: '1.3rem',
                            lineHeight: 1.5,
                        }}
                    >
                        Faça login para acessar as ferramentas de conversão de documentos
                    </Typography>

                    <Button
                        variant="contained"
                        size="large"
                        onClick={handleLogin}
                        startIcon={<LoginIcon />}
                        sx={{
                            py: 2,
                            px: 6,
                            fontSize: '1.2rem',
                            fontWeight: 700,
                            borderRadius: 3,
                            bgcolor: 'primary.main',
                            '&:hover': {
                                bgcolor: 'primary.dark',
                                transform: 'translateY(-2px)',
                                boxShadow: '0 8px 25px rgba(0,0,0,0.2)',
                            },
                            transition: 'all 0.3s ease',
                        }}
                    >
                        Entrar com Microsoft
                    </Button>
                </Paper>
            </Container>
        </Box>
    );
};

export default Login; 